import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Cart } from '../models/Cart';
import { ShoppingCartService } from '../shopping-cart/shopping-cart.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
    // private _isLoggedIn$ = new BehaviorSubject<boolean>(false);
    // isLoggedIn$ = this._isLoggedIn$.asObservable();

    public _userData$ = new BehaviorSubject<any>([]);
    userData$ = this._userData$.asObservable();

    constructor(private router: Router, private http: HttpClient,
        private cartService: ShoppingCartService) {
        // const token = localStorage.getItem('mnpf_auth');
        // this._isLoggedIn$.next(!!token);

        const userData: any = localStorage.getItem('mnpf_auth');
        if(userData) {
            this._userData$.next(JSON.parse(userData))
        } else {
            this._userData$.next(null)
        }
        // console.log("constructor ", userData)
    }

    loginByHeader(username: string, password: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Basic ' + btoa(username + ':' + password))
        return this.http.get(environment.apiUrl + `/api/user`, {
                headers: headers
            })
            .pipe(map((user: any) => {
                // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
                console.log("AuthenticationService>loginByHeader: ", user);
                user.authdata = window.btoa(username + ':' + password);
                localStorage.setItem('mnpf_auth', JSON.stringify(user));
                this._userData$.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('mnpf_auth');
        this._userData$.next(null);

        this.cartService.cart.empty();

        this.router.navigate(['/']);
    }

    signup(data: any): Observable<any>  {
        return this.http.post(environment.apiUrl + `/api/signup`, data);
    }


    // login(username: string, password: string) {
    //     return this.http.post(environment.apiUrl + '/api/users/login', { username, password }).pipe(
    //         tap((response: any) => {
    //             this._isLoggedIn$.next(true);
    //             localStorage.setItem('mnpf_auth', response.token);
    //         })
    //     );
    // }

    // get token(): any {
    //     return localStorage.getItem('mnpf_auth');
    // }
}